var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-2 w-full bg-gray-200",class:{ 'my-2': _vm.spacing }},[_c('div',{staticClass:"h-2 w-full transition-width duration-200",class:_vm.css || 'bg-primary-500 ',style:(_vm.styleObject)})])}
var staticRenderFns = []

export { render, staticRenderFns }